import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { KALA } from '@store/models';

@Component({
    selector: 'app-ka-la-ui',
    templateUrl: './ka-la.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KALAComponent {

    @Input() kalas: KALA[];
    @Output() dismiss = new EventEmitter();
    @Output() gotoSag = new EventEmitter<KALA>();

    onGotoSag(client: KALA) {
        this.gotoSag.emit(client);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
